<!-- eslint-disable -->
<template>
  <CommonPages id="disclaimer" :class="['disclaimer-page']" :titlePrefix="'Disclaimer'"
    :metaDescription="domainConfig?.['meta']?.des || 'Disclaimer and limitations of our website information'">
    <div class="privacy-full">
      <div class="privacy-full__container">
        <div class="privacy-full__content">
          <h1 class="privacy-full__title">Disclaimer</h1>
          <div class="privacy-full__body">
            <div class="privacy-section">
              <p class="privacy-section__text">
                The AI-generated names provided on this website are for creative inspiration and
                entertainment purposes
                only.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">1. No Professional Advice</h2>
              <p class="privacy-section__text">
                The site does not provide legal, business, or branding advice. Users should consult
                professionals
                before making legal or financial decisions based on AI-generated names.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">2. Content Accuracy</h2>
              <p class="privacy-section__text">
                Generated names are created algorithmically and may unintentionally resemble
                existing brands, names, or
                trademarks. We do not verify or screen results for copyright or legal conflicts.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">3. User Responsibility</h2>
              <p class="privacy-section__text">
                It is your responsibility to ensure that any name you use does not infringe on
                intellectual property or
                violate cultural sensitivities.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">4. External Content</h2>
              <p class="privacy-section__text">
                Links to third-party services or sites are provided for convenience and do not imply
                endorsement. We
                are not responsible for the content or practices of external websites.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">5. Liability</h2>
              <p class="privacy-section__text">
                We are not liable for any harm, dispute, or loss resulting from the use of this
                website or any of its
                generated content.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'

import '@/css/common.scss';

export default {
  name: 'Disclaimer',
  components: {
    CommonPages
  },
  mixins: [common, adMixin, adTrackingMixin],
  computed: {
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
      'deviceType',
      'domainConfig',
    ]),
  },
  async activated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Disclaimer] Component activated`);
    }
  },
  async mounted () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Disclaimer] Component mounted`);
    }
  },
  deactivated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Disclaimer] Component deactivated`);
    }
  },
  beforeDestroy () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Disclaimer] Component beforeDestroy`);
    }
  },
  methods: {

  }
};
</script>

<style lang="scss">
@import '@/css/variables.scss';

.privacy-full {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	align-self: stretch;
	position: relative;
	width: 100%;
	margin: 0 0 rem(88);

	&__container {
		width: 100%;
		position: relative;
	}

	&__content {
		display: flex;
		flex-direction: column;
		gap: rem(36);
		align-items: flex-start;
		justify-content: flex-start;
		padding: rem(88) rem(180);
		position: relative;
		z-index: 1;
	}

	&__title {
		color: #1a4048;
		font-size: rem(24);
		font-style: normal;
		font-weight: 500;
		line-height: rem(24);
		margin: 0;
	}

	&__body {
		display: flex;
		flex-direction: column;
		gap: rem(36);
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
		align-self: stretch;
	}
}

.privacy-section {
	display: flex;
	flex-direction: column;
	gap: rem(16);
	align-items: flex-start;
	justify-content: flex-start;
	position: relative;
	align-self: stretch;

	&__title {
		color: #1a4048;
		font-size: rem(18);
		font-style: normal;
		font-weight: 500;
		line-height: rem(24);
		margin: 0;
	}

	&__subtitle {
		color: #1a4048;
		font-size: rem(16);
		font-style: normal;
		font-weight: 500;
		line-height: rem(24);
		margin: rem(8) 0;
	}

	&__text {
		color: #1a4048;
		text-align: left;
		font-size: rem(16);
		line-height: rem(28);
		font-weight: 400;
		margin: rem(8) 0;
	}

	&__link {
		color: #1a4048;
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}

	&__list,
	&__numbered-list {
		color: #1a4048;
		padding-left: rem(24);
		margin: rem(8) 0;

		li {
			margin-bottom: rem(10);
			line-height: rem(28);
			font-size: rem(16);

			strong {
				color: #1a4048;
				font-weight: 500;
				display: block;
				margin-bottom: rem(4);
			}
		}
	}

	&__numbered-list {
		counter-reset: section;
		list-style-type: none;
		padding-left: 0;

		> li {
			margin-bottom: rem(24);
			padding-left: rem(24);
			position: relative;

			&:before {
				counter-increment: section;
				content: counter(section) '.';
				position: absolute;
				left: 0;
				color: #1a4048;
				font-weight: 500;
			}
		}
	}
}

// PC端基础样式
.detect_deviece_pc,
.detect_deviece_desktop {
	.privacy-full {
		// PC端特定样式
	}
}

// 移动端基础样式
.detect_deviece_mobile {
	.privacy-full {
		&__content {
			width: 100%;
			padding: rem(40) rem(16);
		}

		&__title {
			font-size: rem(20);
			line-height: rem(20);
		}
	}

	.privacy-section {
		&__title {
			font-size: rem(16);
			line-height: rem(20);
		}

		&__subtitle {
			font-size: rem(14);
			line-height: rem(20);
		}

		&__text {
			font-size: rem(14);
			line-height: rem(24);
		}

		&__list,
		&__numbered-list {
			li {
				font-size: rem(14);
				line-height: rem(24);
			}
		}
	}
}
</style> 